import {FormDialog} from '@management-ui/core';
import {Add, Visibility} from '@mui/icons-material';
import {IconButton, Tooltip} from '@mui/material';
import {reverse} from 'named-urls';
import * as React from 'react';
import {useCallback, useState} from 'react';
import {useHistory} from 'react-router-dom';
import OrderStatus from '../../../../components/OrderStatus';
import Table from '../../../../components/Table';
import routes from '../../../../routes';
import PackingListForm from '../../forms/PackingListForm';

const PackingLists = ({order}) => {
  const history = useHistory();
  const [showNew, setShowNew] = useState(false);

  const goToList = useCallback((list) => {
    history.push(reverse(order.archived ? routes.archive.salesOrder.packingList.detail : routes.salesOrders.packingList.detail, {
      id: order.id,
      listID: list.id
    }));
  }, [order, history]);

  return (
    <>
      <Table>
        <Table.Actions>
          <h3>Packing Lists</h3>
          <Tooltip title="Add New Packing List">
            <span>
              <IconButton
                onClick={() => setShowNew(true)}
                disabled={order.archived}>
                <Add/>
              </IconButton>
            </span>
          </Tooltip>
        </Table.Actions>
        <Table.Row>
          <Table.Header>Customer PO Number</Table.Header>
          <Table.Header>Status</Table.Header>
          <Table.Action/>
        </Table.Row>
        {order.packing_lists.length > 0 ? (
          order.packing_lists.map((list, index) => (
            <Table.Row key={index}>
              <Table.Column>{list.number ?? '-'}</Table.Column>
              <Table.Column><OrderStatus order={list}/></Table.Column>
              <Table.Action>
                <Tooltip title="View Packing List">
                  <span>
                    <IconButton
                      onClick={() => goToList(list)}
                      disabled={order.archived}>
                      <Visibility/>
                    </IconButton>
                  </span>
                </Tooltip>
              </Table.Action>
            </Table.Row>
          ))
        ) : (
          <Table.NoRecords>There are no packing lists associated with this order</Table.NoRecords>
        )}
      </Table>
      <FormDialog
        title="Add New Packing List"
        open={showNew}
        maxWidth="md"
        onClose={() => setShowNew(false)}
        render={(props) => (
          <PackingListForm
            {...props}
            list={{collection_date: order.collection_date, collection_address: order.collection_address}}
            order={order}
            fields="core"
            onSaved={(saved) => goToList(saved)}
          />
        )}
      />
    </>
  );
};

export default PackingLists;
